define('components/course/models/materials-page',[], function(BaseModel) {
    "use strict";

    var Materials = Backbone.Model.extend({

        "defaults": function() {
            return {
                "levelData": [{
                    "levelLabel": "",
                    "levelTitle": "",
                    "levelDescription": "",
                    "levelAssets": [{
                        "type": "",
                        "assetData": {}
                    }],
                    "modules": [{
                        "moduleTitle": "",
                        "moduleIconData": {},
                        "moduleAssets": [{
                            "typeDetails": {},
                            "title": "",
                            "label": "",
                            "description": "",
                            "assetData": {},
                            "videoThumbnail": null //will be {} when asset type video is selected
                        }]
                    }]
                }]
            };
        }
    }, {
        "MODULE_ASSET_TYPE": {
            "VIDEO": {
                "TYPE": "VIDEO",
                "TEXT": "Video"
            },
            "PDF": {
                "TYPE": "PDF",
                "TEXT": "Pdf"
            }
        },

        "LEVEL_CONTENT": {
            "LABEL": "Level handbook",
            "MODULE": {
                "ASSET": {
                    "VIDEO": {
                        "LABEL": "Video"
                    },
                    "PDF": {
                        "LABEL": "Module resource & reference guide"
                    }
                }
            }
        },

        "WINDOW_CONFIG": {
            "VIDEO": {
                "width": 600,
                "height": 500
            },
            "PDF": {
                "width": 600,
                "height": 1000
            }
        }
    });
    return Materials;
});

